import Vue from 'vue';

import { abilitiesPlugin } from '@casl/vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Notifications from 'vue-notification';


import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

import vuetify from './plugins/vuetify';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(abilitiesPlugin);
Vue.use(Notifications);


Vue.component('l-map', LMap);
Vue.component('l-tilelayer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-popup', LPopup);

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');
